<span
  class="dropdown-el"
  #dropDownEl
  (click)="onClick()"
  [style.width]="width()"
  [class.expanded]="isExpanded()"
>
  @for (item of list(); track $index; let i = $index) {
  <input
    type="radio"
    name="sortType"
    [value]="item | selectItemField: valueField()"
    [checked]="selectedItemIndex() === i"
  />
  <label (click)="onSelectItem(i)">
    {{ item | selectItemField: displayField() }}
  </label>
  }
</span>
